<template>
  <div class="Contact" id="Contact">
    <v-app>
      <v-app-bar app color='primary' dark height="564" absolute>
        <v-row align="start">
          <!-- 一级导航栏 -->
          <FirstNavbar :tab_index="first_active_tab" :barHide="barHide" :barColor="barColor" :pc='pc'></FirstNavbar>
          <div class='first_title_box'  style="width:100%;height:calc(564px - 64px);" >
            <v-row align="center" justify="center">
              <v-col cols="12">
                <h1 class="first_title white--text">
                  联系我们
                </h1>
                <h4 class="body_text white--text">
                  <span>诚信</span><span>规范</span><span>创新</span><span>高效</span>
                </h4>
              </v-col>
            </v-row>
          </div>
          <!-- 首屏大图 -->
          <div style="width:100%;height:500px;position:absolute;z-index:-3;margin-left:-4px">
            <v-parallax height="564" dark src="../assets/images/bg_contact.png">
            </v-parallax>
          </div>
        </v-row>
      </v-app-bar>
      <v-main>
        <div class="aboutContent">
          <v-row dense>
            <v-col cols="12">
              <BoxTitle firstTitle='联系我们' desc='' :index="1"></BoxTitle>
              <BoxSpaceAround :data='contentList[0].children[0]' :dark="false" :img_top="true" img_size='40%' card_width="12rem" card_height="15rem"></BoxSpaceAround>
              <div class='contentBox'>
                <v-row  class="fill-height" align="center" :justify="card_align">
                  <v-card
                    color='#e7eefb'
                    class="ma-4 rounded-xl"
                    height="auto"
                    :width="cardWidth"
                    v-for='li in contactsList' :key='li.index'
                    style="padding:1rem"
                    elevation="1"
                  >
                  <v-icon size="48" color="white" style="position:absolute;top:1rem;right:1rem">mdi-card-account-details-star</v-icon>
                  <v-list-item>
                    <v-list-item-content>
                      <p class="body_text text_strong">{{li.position}}</p>
                      <v-list-item-subtitle>
                        <p class="body_text" style="font-size:1.2rem;">{{li.name}}</p>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <p class="body_text">电话</p>
                      <v-list-item-subtitle>
                        <p class="card_text" style="letter-spacing:0;">{{li.tel}}</p>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <p class="body_text">邮箱</p>
                      <v-list-item-subtitle>
                        <p class="card_text" style="letter-spacing:0;">{{li.email}}</p>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  </v-card>
                </v-row>
              </div>
              <!-- 联系我们 -->
              <div id="contact" class="contact">
                <v-col class="text-center" cols="12">
                  <v-row>
                    <v-col cols="12">
                      <h1 class="second_title font-weight-thin mb-4 white--text">
                        预约参观
                      </h1>
                      <h4 class="subheading body_text white--text">
                      </h4>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <Booking></Booking>
                  </v-row>
                </v-col>
              </div>
              <!-- 悬浮图标-回到顶部 -->
              <v-fab-transition>
                <v-btn
                  v-show="!floatHidden"
                  color="primary"
                  fixed
                  bottom
                  right
                  fab
                  @click="goTo(0)"
                >
                  <v-icon>mdi-arrow-up</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-col>
          </v-row>
        </div>
      </v-main>
    <v-footer  color="secondary" style="height:auto">
      <FootContent :active="footList.active" :listWidth="footList.listWidth"></FootContent>
    </v-footer>
    </v-app>
  </div>
</template>

<script>
import FootContent from '../components/footer.vue'
import FirstNavbar from '../components/first-navbar.vue'
import Booking from '../components/booking.vue'
import BoxTitle from '../components/box-title.vue'
import BoxSpaceAround from '../components/box-space-around.vue'

export default {
  name: 'Content',

  components: {
    FootContent,
    FirstNavbar,
    Booking,
    BoxTitle,
    BoxSpaceAround
  },
  data: () => ({
    // 名片对齐方式
    card_align: 'center',
    // 名片宽度
    cardWidth: '16rem',
    // 导航背景颜色
    barColor: 'rgba(63, 81, 181,0)',
    // 导航栏是否隐藏
    barHide: true,
    // 是否为PC端
    pc: false,
    // 悬浮按钮是否隐藏
    floatHidden: true,
    // 一级导航选项卡
    first_active_tab: 6,
    // 页脚参数
    footList: {
      listWidth: '10rem',
      active: [true, true, true]
    },
    // 内容列表
    contentList: [{
      index: 1,
      firstTitle: '联系方式',
      desc: '',
      scrollTop: '',
      children: [{
        index: 1,
        src: '',
        content: {
          title: '',
          body: '',
          btn: '',
          list: [{
            index: 1,
            src: 'lxwm1.png',
            title: '电话',
            subtitle: '',
            body: '0312-6967888'
          }, {
            index: 2,
            src: 'lxwm2.png',
            title: '邮箱',
            subtitle: '',
            body: 'jxfm@hbjxfm.com'
          }, {
            index: 3,
            src: 'lxwm3.png',
            title: '传真',
            subtitle: '',
            body: '0312-6967888'
          }, {
            index: 4,
            src: 'lxwm4.png',
            title: '地址',
            subtitle: '',
            body: '河北省保定市<br>定兴县福朔路166号'
          }]
        }
      }]
    }],
    contactsList: [{
      name: '柳先生',
      position: '产品服务联系人',
      tel: '16630230128',
      email: 'jishubu@hbjxfm.com'
    }, {
      name: '罗先生',
      position: '供应商联系人',
      tel: '16630230155',
      email: 'supplier@hbjxfm.com'
    }, {
      name: '罗先生',
      position: '市场营销联系人',
      tel: '16630230155',
      email: 'marketing@hbjxfm.com'
    }, {
      name: '林先生',
      position: '人力资源联系人',
      tel: '16630230135',
      email: 'hr@hbjxfm.com'
    }]
  }),
  mounted () {
    this.goTo(0)
    var that = this
    that.whatScreen()
    // 屏幕尺寸监听
    window.onresize = function () {
      that.whatScreen()
    }
  },
  methods: {
    // 屏幕
    whatScreen () {
      var width = document.querySelector('html').offsetWidth
      if (width <= 768) {
        // title.innerHTML = "极小屏幕-" + width
        this.footList.active = [false, false, false]
        this.footList.listWidth = '90rem'
        this.pc = false
        this.card_align = 'center'
        this.cardWidth = '16rem'
      } else {
        if (width > 768 && width <= 992) {
          // title.innerHTML = "小屏幕-" + width
          this.footList.active = [true, true, true]
          this.footList.listWidth = '10rem'
          this.pc = false
          this.card_align = 'center'
          this.cardWidth = '16rem'
        } else {
          if (width > 992 && width <= 1330) {
            // title.innerHTML = "普通屏幕-" + width
            this.footList.active = [true, true, true]
            this.footList.listWidth = '10rem'
            this.pc = true
            this.card_align = 'space-around'
            this.cardWidth = '23rem'
          } else {
            if (width > 1330 && width <= 1600) {
              // title.innerHTML = "大屏幕-" + width
              this.footList.active = [true, true, true]
              this.footList.listWidth = '10rem'
              this.pc = true
              this.card_align = 'space-around'
              this.cardWidth = '16rem'
            } else {
              if (width > 1600) {
                // title.innerHTML = "大屏幕-" + width
                this.footList.listWidth = '10rem'
                this.footList.active = [true, true, true]
                this.pc = true
                this.card_align = 'space-around'
                this.cardWidth = '16rem'
              }
            }
          }
        }
      }
    },
    // 一级导航跳转定位
    toguid (path_, id) {
      const path = path_
      const Id = id
      localStorage.setItem('toId', Id)
      this.$router.push(path)
    },
    goTo (ele) {
      document.body.scrollTop = ele
      document.documentElement.scrollTop = ele
    }
  }

}
</script>

<style>

</style>
